






























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import RankLegDistributorEntity from '@/earn/entities/rank-leg-status/rank-leg-distributor.entity';
import VCard from '@/_shared/components/v-card/v-card.component.vue';

@Component({
  components: { VCard },
})
export default class RankLegUser extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  public user!: RankLegDistributorEntity;

  openVCard(): void {
    (this.$refs.vCard as VCard).show(this.user.id);
  }
}
